import React from 'react';

interface ModalContextValue {
  closeModal: () => void;
}
export default React.createContext<ModalContextValue>({
  closeModal: () => undefined,
});
